<template>
    <div v-if="item">
        <CheckboxField
            :name="item.Id"
            @update:modelValue="(value: boolean) => onUpdateValue(value)">
            <div class="disclaimer-checkbox-content">
                {{ item.Label }}
                <template v-if="item.LinkText && item.LinkUrl">
                    <Link
                        v-if="showLink"
                        :href="item.LinkUrl"
                        :label="item.LinkText"
                        target="_blank"
                        class="link" />
                    <ButtonLink v-else size="m" :onClick="toggleModal" class="link">
                        {{ item.LinkText }}
                    </ButtonLink>
                </template>
            </div>
        </CheckboxField>

        <Modal v-if="item.LinkUrl && showModal" :onClose="toggleModal" size="xl">
            <Iframe :src="item.LinkUrl" :modal="true" :border="true" />
        </Modal>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType, ref } from 'vue';
    import { Disclaimer } from '@/api/Checkout/checkout.interfaces';
    import CheckboxField from '@ui/components/FormV2/Fields/Checkbox/CheckboxField.vue';
    import Modal from '@ui/components/Modal/Modal.vue';
    import Iframe from '@ui/components/Iframe/Iframe.vue';
    import ButtonLink from '@ui/components/Button/ButtonLink.vue';
    import { t } from '@shared/helpers/translation';
    import Link from '@ui/components/Link/Link.vue';
    import { disclaimersToRedirect } from '@/helpers/termsAndPoliciesLinks';

    export default defineComponent({
        name: 'DisclaimerCheckbox',
        methods: { t },
        components: { Link, ButtonLink, Iframe, Modal, CheckboxField },
        emits: ['update:modelValue'],
        props: {
            item: {
                type: Object as PropType<Disclaimer>,
                required: true,
            },
        },
        setup(props, { emit }) {
            const showModal = ref(false);

            const showLink = computed(() => disclaimersToRedirect.includes(props.item.Id));

            function toggleModal() {
                showModal.value = !showModal.value;
            }

            function onUpdateValue(state: boolean) {
                emit('update:modelValue', state);
            }

            return {
                showLink,
                showModal,
                toggleModal,
                onUpdateValue,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './DisclaimerCheckbox.scss';
</style>
